import {useAppSelector} from 'store/hooks';
import type {EntityEditStatus} from '../types';
import {selectMetadataEditEditStatuses} from '../metadataEditSlice';

const DEFAULT_EDIT_STATUS: EntityEditStatus = {
  hasDataChanged: false,
  hasMoved: false,
};

export const useEditStatus = (id: string): EntityEditStatus => {
  const status =
    useAppSelector(selectMetadataEditEditStatuses)[id] ?? DEFAULT_EDIT_STATUS;
  return status;
};
